import {Component, EventEmitter, HostBinding, HostListener, Input, Output} from '@angular/core';

import {SortState} from './table.constants';

import {isBlank} from '../../utils/lang';

@Component({
  selector: 'th[gp-table-column]',
  template: `
    <div>
      <ng-content></ng-content>
      <i aria-hidden="true" *ngIf="sortKey" class="fa fa-solid"
         [ngClass]="{
          'text-muted': headerSortState === SortState.INACTIVE,
          'fa-sort-up': headerSortState !== SortState.REVERTED,
          'fa-sort-down': headerSortState === SortState.REVERTED
         }"></i>
    </div>
  `
})
export class TableColumnHeader {

  @HostBinding('class.pointer')
  get clickable() {
    return this.isSortKeyAvailable();
  }

  @HostBinding('class.sortable')
  get sortable() {
    return this.isSortKeyAvailable();
  }

  @HostBinding('class.text-sm')
  get small() {
    return true;
  }

  @Input('sort-key')
  public sortKey: string;

  @Input('default-sort')
  public defaultSort: string;

  @Output()
  public sortEvents: EventEmitter<string> = new EventEmitter<string>();

  // State of the sort, controlled by the table component
  public headerSortState: SortState = SortState.INACTIVE;

  // Template access to the enum
  public SortState: any = SortState;

  @HostListener('click')
  public onClick() {
    if (this.sortable) {
      this.sortEvents.emit(this.sortKey);
    }
  }

  private isSortKeyAvailable(): boolean {
    return !isBlank(this.sortKey) && this.sortKey.length > 0;
  }

}
